import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import { TypeAnimation } from 'react-type-animation';
import { isEmpty } from 'lodash';
import { useWindowSize } from 'react-use';
import { useNextStyleRouter } from '../../hooks/useNextStyleRouter';
import NCRDesktopSliderForm from '../leads/LeadForm/SliderForm/SliderForm';
import NewModalOverlay from '../components/modal/NewModalOverlay';
import EnquiryForm from '../venues/components/EnquiryForm';
import styles from './embeddedleadForm.module.css';
import getquotestyles from './getquote.module.css';
import {
  DISCOVER_AND_BOOK,
  GET_QOTES_TYPICAL_TEXT_SOCIAL,
  GET_QUOTES_HEADER,
  GET_QUOTES_SUB_HEADING,
  GET_QUOTES_TYPICAL_TEXT_CORPORATE,
  GET_QUOTES_TYPICAL_TEXT_WEDDING,
  carouselimage,
  discoverandbook,
} from '../../constants/leadFormConstants';
import Icon from '../../layouts/common/icons/Icon';
import { GET_QUOTE_DO_YOU_NEED_ASSISTANCE } from '../../constants/enquiryFormConst';
import {
  setEnquiryFormVisible,
  setEnquiryFormVisibleState,
} from '../../redux/actions/LeadFormActions';
import {
  DESTINATION_WEDDING_MODEL,
  MODELS,
  VENUE_MODEL,
  cityMap,
} from '../../constants/constants';
import { getSelectedEvent } from '../../redux/selectors/EventSelectors';
import { recordPageLoad } from '../../util/vmTrackingHandler';
import { getCurrentSelectedCityPage } from '../../redux/actions/LeadActions';
import { setUserCity } from '../../redux/actions/HeaderActions';
import { getEnquiryFormBtnText } from '../../util/leadFormUtility';
import { DO_YOU_NEED_ASSISTANCE } from '../../constants/enquiryFormConst';
import { DO_YOU_NEED_ASSISTANCE_CALL } from '../../constants/HaveUsCallYouBannerConst';
import { getEnquiryFormVisibilityState } from '../../redux/selectors/LeadFormSelectors';

const iconTone = ['gq-icon-wrap--gold', 'gq-icon-wrap--slate', 'gq-icon-wrap--green'];

/** Full-bleed hero background (replaces static photo) */
const heroBackgroundCarouselSettings = {
  fade: true,
  infinite: true,
  speed: 900,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
  dots: false,
  pauseOnHover: false,
  draggable: false,
};

function LeadFormEmbeddedPage({ overRideForm, leadFormMode }) {
  const router = useNextStyleRouter();
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const event = useSelector((state) => getSelectedEvent(state));
  const isEnquiryFormVisible = useSelector((state) => getEnquiryFormVisibilityState(state));

  const currentUrl = router.asPath;

  useEffect(() => {
    if (overRideForm && cityMap[overRideForm]) {
      const city = cityMap[overRideForm];
      dispatch(getCurrentSelectedCityPage(city));
      dispatch(setUserCity(city));
    }
    recordPageLoad('page', 'EBDP', 'EBDP', currentUrl, '');
  }, []);

  const pageSource = () => {
    if (overRideForm === 'mumbai' || overRideForm === 'noida') {
      return 'gqm';
    }
    if (overRideForm === 'jaipur') {
      return 'gqj';
    }
    if (overRideForm === 'rajasthan') {
      return 'gqr';
    }
    return 'gq';
  };

  const closeEnquiryOverlay = () => {
    dispatch(setEnquiryFormVisibleState(false));
  };

  const onNeedAssistenceClick = () => {
    dispatch(
      setEnquiryFormVisible({
        pageType: 'get-quote-lp',
        formType: GET_QUOTE_DO_YOU_NEED_ASSISTANCE,
        btnSource: 'get_quote_lp_do_you_need_assistance',
        leadType: MODELS[VENUE_MODEL].lead_type,
      })
    );
  };

  const getLeadform = () => (
    <div className={styles['form-container-wrapper']}>
      <div className={styles['form-sub-container']}>
        <NCRDesktopSliderForm
          router={router}
          pageSource={pageSource()}
          overRideForm={overRideForm ? overRideForm : null}
          embeddedLpStyle="get-quote"
          leadFormMode={
            leadFormMode === DESTINATION_WEDDING_MODEL ? DESTINATION_WEDDING_MODEL : VENUE_MODEL
          }
        />
      </div>
    </div>
  );

  /* Match modal breakpoint: same as width > 768 elsewhere on this page */
  const isFormOnlyLayout = typeof width === 'number' && width <= 768;

  const discoverSection = (
    <section className={getquotestyles['gq-features']}>
      <h2 className={getquotestyles['gq-features-title']}>{DISCOVER_AND_BOOK}</h2>
      <div className={getquotestyles['gq-card-row']}>
        {discoverandbook.map((card, index) => (
          <div key={card.heading} className={getquotestyles['gq-card']}>
            <div
              className={`${getquotestyles['gq-icon-wrap']} ${getquotestyles[iconTone[index]]}`}
            >
              <Icon iconName={card.icon} className={getquotestyles['gq-card-icon']} />
            </div>
            <p className={getquotestyles['gq-card-heading']}>{card.heading}</p>
            <p className={getquotestyles['gq-card-desc']}>{card.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );

  const assistanceSection = isEmpty(event) ? (
    <section className={getquotestyles['gq-assist']}>
      <div className={getquotestyles['gq-assist-inner']}>
        <div className={getquotestyles['gq-assist-copy']}>
          <p className={getquotestyles['gq-assist-line']}>
            Do you need <span className={getquotestyles['gq-assist-accent']}>assistance?</span>
          </p>
          <p className={getquotestyles['gq-assist-meta']}>Get in touch with an expert</p>
          <p className={getquotestyles['gq-assist-phone']}>{DO_YOU_NEED_ASSISTANCE_CALL}</p>
        </div>
        <button
          type="button"
          className={getquotestyles['gq-assist-btn']}
          onClick={onNeedAssistenceClick}
        >
          {getEnquiryFormBtnText(DO_YOU_NEED_ASSISTANCE)}
        </button>
      </div>
    </section>
  ) : null;

  console.log('ROUTERREEEE', router);

  return (
    <>
    <div className={getquotestyles['get-quote-lp']}>
      {isFormOnlyLayout ? (
        <>
          <div className={getquotestyles.gqMobileFormOnly}>{getLeadform()}</div>
          {discoverSection}
          {assistanceSection}
        </>
      ) : (
        <>
      <section className={getquotestyles['gq-hero']}>
        <div className={getquotestyles['gq-hero-bg-carousel']} aria-hidden>
          <Slider {...heroBackgroundCarouselSettings}>
            {carouselimage.map((image) => (
              <div key={image.id}>
                <div className={getquotestyles['gq-hero-bg-slide']}>
                  <img src={image.icon} alt="" />
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className={getquotestyles['gq-hero-overlay']} aria-hidden />
        <div className={getquotestyles['gq-hero-inner']}>
          <div className={getquotestyles['gq-hero-copy']}>
            <div className={getquotestyles['banner-container']}>
              <div className={getquotestyles['banner-text-container']}>
                  <p
                    className={`${getquotestyles['get-quote-header']} ${getquotestyles['gq-hero-typed-title']}`}
                  >
                    {GET_QUOTES_HEADER}{' '}
                    <TypeAnimation
                      repeat={Infinity}
                      wrapper="span"
                      cursor
                      sequence={[
                        GET_QUOTES_TYPICAL_TEXT_WEDDING,
                        1200,
                        GET_QUOTES_TYPICAL_TEXT_CORPORATE,
                        1200,
                        GET_QOTES_TYPICAL_TEXT_SOCIAL,
                        1200,
                      ]}
                      style={{ color: 'white' }}
                    />
                  </p>
                  <p
                    className={getquotestyles['get-quote-subheading']}
                  >
                    {GET_QUOTES_SUB_HEADING}
                  </p>
              </div>
            </div>
          </div>
          <div className={getquotestyles['gq-hero-form']}>{getLeadform()}</div>
        </div>
      </section>

      {discoverSection}
      {assistanceSection}
        </>
      )}
    </div>
    {isEnquiryFormVisible ? (
      <NewModalOverlay
        isOverlayOpen={isEnquiryFormVisible}
        closeOverlay={closeEnquiryOverlay}
        width={width > 768 ? '400px' : '100%'}
        height={width > 768 ? '600px' : '100%'}
        borderRadius="8px"
        padding="16px"
      >
        <EnquiryForm />
      </NewModalOverlay>
    ) : null}
    </>
  );
}

export default LeadFormEmbeddedPage;
